<script setup>
import { useI18n } from "vue-i18n";
import { AlertCircle } from "lucide-vue-next";

defineEmits(["retry"]);
const { t } = useI18n();
</script>

<template>
  <div class="w-[360px] p-6 flex flex-col items-center gap-3 text-center">
    <AlertCircle class="h-6 w-6 text-destructive" aria-hidden="true" />
    <div class="text-sm text-foreground">
      {{ t("Не удалось загрузить") }}
    </div>
    <button
      type="button"
      class="inline-flex h-8 items-center justify-center rounded-[var(--radius)] border border-input bg-background px-3 text-sm font-medium transition-colors hover:bg-accent hover:text-accent-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      @click="$emit('retry')"
    >
      {{ t("Повторить") }}
    </button>
  </div>
</template>
